import React, { useId } from 'react';
import forwardRef from '../../../private/forwardRef';
import { IconProps } from '../icon.types';

const WalkingMd = forwardRef<IconProps, 'svg'>(
    ({ className, ...props }, ref) => {
        const autoTitleId = useId();
        const titleId = props?.id ? `${props.id}-title` : autoTitleId;
        return (
            <svg
                className={['Nitty__Icon--md', className]
                    .filter(Boolean)
                    .join(' ')}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                ref={ref}
                aria-labelledby={props?.title ? titleId : undefined}
                {...props}
            >
                {props?.title && <title id={titleId}>{props.title}</title>}
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="currentColor"
                    d="M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2zM9.8 8.9L7.24 21.81c-.13.61.35 1.19.98 1.19h.08c.47 0 .87-.32.98-.78L10.9 15l2.1 2v5c0 .55.45 1 1 1s1-.45 1-1v-5.64c0-.55-.22-1.07-.62-1.45L12.9 13.5l.6-3a7.321 7.321 0 0 0 4.36 2.41c.6.09 1.14-.39 1.14-1c0-.49-.36-.9-.85-.98c-1.52-.25-2.78-1.15-3.45-2.33l-1-1.6a2.145 2.145 0 0 0-2.65-.84L7.22 7.78A2.01 2.01 0 0 0 6 9.63V12c0 .55.45 1 1 1s1-.45 1-1V9.6l1.8-.7"
                />
            </svg>
        );
    },
);

WalkingMd.displayName = 'WalkingMd';

export default WalkingMd;
